document.addEventListener('click', async (event) => {
  const button = event.target.closest('.collection-load-more__button');
  if (!button) return;

  const nextUrl = button.dataset.nextUrl;
  if (!nextUrl) return;

  button.disabled = true;

  try {
    const response = await fetch(nextUrl);
    if (!response.ok) throw new Error('Failed to load products');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

   const currentGrid =
  document.querySelector('#product-grid.product-grid') ||
  document.querySelector('#product-grid ul.product-grid');

const nextGrid =
  doc.querySelector('#product-grid.product-grid') ||
  doc.querySelector('#product-grid ul.product-grid');

    if (!currentGrid || !nextGrid) return;

    nextGrid.querySelectorAll('.grid__item').forEach((item) => {
      currentGrid.appendChild(item);
    });

    const nextButton = doc.querySelector('.collection-load-more__button');

    if (nextButton?.dataset.nextUrl) {
      button.dataset.nextUrl = nextButton.dataset.nextUrl;
      button.disabled = false;
    } else {
      button.closest('.collection-load-more')?.remove();
    }
  } catch (error) {
    console.error('Load more error:', error);
    button.disabled = false;
  }
});